import { MenuItem as MUIMenuItem, type MenuItemProps } from '@mui/material';

export { type MenuItemProps } from '@mui/material';

export function MenuItem(props: MenuItemProps) {
  return <MUIMenuItem {...props} />;
}
